export default __webpack_public_path__ + "static/media/send.ace0581f.svg";